// extracted by mini-css-extract-plugin
export default {"cancelLink":"MQ-z"};